import { ObjectField, Int32Field, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class NeonLine extends ObjectField {
    static create(construct) {
        return new NeonLine(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get wave1() {
        return this.getField(1);
    }
    get wave2() {
        return this.getField(2);
    }
    get dcwKeyFollow() {
        return this.getField(3);
    }
    get dcaKeyFollow() {
        return this.getField(4);
    }
    initializeFields() {
        return {
            1: Int32Field.create({
                parent: this,
                fieldKey: 1,
                fieldName: "wave1",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { length: 8 }, "", 0),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "wave2",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { length: 9 }, "", 0),
            3: Float32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "dcwKeyFollow",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 9, scaling: "linear" }, "", 0),
            4: Float32Field.create({
                parent: this,
                fieldKey: 4,
                fieldName: "dcaKeyFollow",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 9, scaling: "linear" }, "", 0),
        };
    }
}
